var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n    "+_vm._s(_vm.getValue.int)),_c('span',[_vm._v(_vm._s(_vm.getValue.frac))])])
}
var staticRenderFns = []

export { render, staticRenderFns }